var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMale = function SvgMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.955 1.125-.017-.013a1.061 1.061 0 0 0-.915-.29L11.325.87a1.06 1.06 0 0 0-1.045 1.072c.007.584.45 1.019 1.072 1.045l1.238-.016-1.812 1.812a6.269 6.269 0 0 0-3.74-1.224 6.276 6.276 0 0 0-4.467 1.85 6.326 6.326 0 0 0 0 8.933 6.277 6.277 0 0 0 4.467 1.85 6.278 6.278 0 0 0 4.467-1.85 6.331 6.331 0 0 0 .75-8.036l1.902-1.897v1.385a1.059 1.059 0 0 0 2.118 0V1.876c0-.281-.119-.553-.32-.751Zm-5.947 11.72c-1.586 1.586-4.351 1.586-5.939 0a4.204 4.204 0 0 1 0-5.94 4.175 4.175 0 0 1 2.97-1.23 4.18 4.18 0 0 1 2.971 1.23 4.204 4.204 0 0 1-.002 5.94Z",
    fill: "#fff"
  })));
};
export default SvgMale;